import { PermissionActions } from '@/features/permissions/permissionActions.js'
import SuperAdminDummyRouter from '@/features/superAdmin/SuperAdminDummyRouter.vue'

export const membershipManagementRoutes = [
  {
    path: 'membership-management',
    component: SuperAdminDummyRouter,
    meta: { permissionAction: PermissionActions.MembershipsView },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/membershipManagement/list/MembershipListView.vue'),
        meta: { permissionAction: PermissionActions.MembershipsView },
      },
      {
        path: ':membershipId',
        component: () =>
          import('@/features/settingsManagement/membershipManagement/edit/MembershipTabbedEditView.vue'),
        meta: { permissionAction: PermissionActions.MembershipsView },
      },
      {
        path: 'new',
        component: () =>
          import('@/features/settingsManagement/membershipManagement/edit/MembershipEditView.vue'),
        meta: { permissionAction: PermissionActions.MembershipsCreate },
      },
    ],
  },
]
